import {connect} from 'react-redux';

import {getFlatTeammates} from '../../../../../libs/shared/core/src/store/data/teammates/commonTeammatesSelectors';
import {
  makeMapDispatchToProps,
  makeMapStateToProps,
  wrapInShallowSelector,
} from '../../../../../srcCommon/helpers/reselectHelpers';
import {searchForCardsAsyncAction} from '../../../../store/data/cards/cardsActions';
import {getAccounts} from '../../../../store/data/dataSelectors';
import {getOnlineTeammateIdsSet} from '../../../../store/data/teammates/onlineTeammatesSelectors';
import {SearchContactsDropdown} from './searchContactsDropdown';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  accounts: getAccounts,
  teammates: wrapInShallowSelector(getFlatTeammates),
  onlineTeammateIds: getOnlineTeammateIdsSet,
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  searchForCardsAsync: searchForCardsAsyncAction,
}));

export const SearchContactsDropdownContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchContactsDropdown);
